export default __webpack_public_path__ + "static/credit-card-light.png";